// src/RapportMensuelManager.js
import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

const RapportMensuelManager = () => {
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [sending, setSending] = useState(false);
  const [sendResult, setSendResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.from('rapport_config').select('emails_destinataires').eq('actif', true).single()
      .then(({ data }) => {
        if (data?.emails_destinataires) setEmails(data.emails_destinataires);
        setLoading(false);
      });
  }, []);

  const sauvegarder = async () => {
    setSaving(true);
    await supabase.from('rapport_config').update({ emails_destinataires: emails }).eq('actif', true);
    setSaving(false); setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const ajouterEmail = () => {
    if (!newEmail || !newEmail.includes('@')) return;
    if (!emails.includes(newEmail)) setEmails(prev => [...prev, newEmail]);
    setNewEmail('');
  };

  const supprimerEmail = (email) => setEmails(prev => prev.filter(e => e !== email));

  const envoyerTest = async () => {
    setSending(true); setSendResult(null);
    try {
      const resp = await fetch('https://slbjqrqgbxdvcpjxgylr.supabase.co/functions/v1/rapport-test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}` },
        body: JSON.stringify({ emails }),
      });
      if (resp.ok) setSendResult({ ok: true, msg: 'Rapport de test envoyé !' });
      else setSendResult({ ok: false, msg: 'Erreur lors de l\'envoi.' });
    } catch {
      setSendResult({ ok: false, msg: 'Erreur de connexion.' });
    }
    setSending(false);
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Chargement...</div>;

  return (
    <div style={{ padding: '24px', maxWidth: '700px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h2 style={{ fontSize: '20px', fontWeight: 800, color: '#1f2937', margin: 0 }}>📧 Rapport mensuel automatique</h2>
          <p style={{ fontSize: '13px', color: '#6b7280', margin: '4px 0 0' }}>
            Envoyé automatiquement le <strong>1er de chaque mois à 7h00</strong> via Resend
          </p>
        </div>
      </div>

      {/* Info cron */}
      <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '14px 16px', marginBottom: '20px', display: 'flex', gap: '12px', alignItems: 'center' }}>
        <span style={{ fontSize: '20px' }}>⏰</span>
        <div>
          <div style={{ fontWeight: 700, fontSize: '13px', color: '#1e40af' }}>Cron job actif sur le VPS</div>
          <div style={{ fontSize: '12px', color: '#3b82f6', marginTop: '2px' }}>
            <code style={{ background: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>0 7 1 * *</code>
            {' '}— Chaque 1er du mois à 7h00 · Logs : <code style={{ background: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>/var/log/rapport_mensuel.log</code>
          </div>
        </div>
      </div>

      {/* Destinataires */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '20px', border: '1px solid #e5e7eb', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
        <div style={{ fontWeight: 700, fontSize: '15px', color: '#1f2937', marginBottom: '16px' }}>
          📬 Destinataires du rapport
        </div>

        {/* Liste emails */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
          {emails.map(email => (
            <div key={email} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8fafc', borderRadius: '8px', padding: '10px 14px', border: '1px solid #e5e7eb' }}>
              <span style={{ fontSize: '14px', color: '#1f2937' }}>📧 {email}</span>
              <button onClick={() => supprimerEmail(email)}
                style={{ background: '#fee2e2', border: 'none', color: '#ef4444', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>
                Supprimer
              </button>
            </div>
          ))}
          {emails.length === 0 && (
            <div style={{ color: '#9ca3af', fontSize: '13px', textAlign: 'center', padding: '16px' }}>
              Aucun destinataire configuré
            </div>
          )}
        </div>

        {/* Ajouter email */}
        <div style={{ display: 'flex', gap: '8px' }}>
          <input
            type="email" value={newEmail}
            onChange={e => setNewEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && ajouterEmail()}
            placeholder="nouvel.email@exemple.com"
            style={{ flex: 1, border: '1px solid #e5e7eb', borderRadius: '8px', padding: '8px 12px', fontSize: '14px', outline: 'none' }}
          />
          <button onClick={ajouterEmail}
            style={{ background: '#1e40af', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontSize: '14px', fontWeight: 600 }}>
            + Ajouter
          </button>
        </div>

        <button onClick={sauvegarder} disabled={saving}
          style={{ marginTop: '16px', width: '100%', background: saved ? '#10b981' : '#1e40af', color: 'white', border: 'none', borderRadius: '8px', padding: '10px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s' }}>
          {saving ? '⏳ Sauvegarde...' : saved ? '✅ Sauvegardé !' : '💾 Sauvegarder les destinataires'}
        </button>
      </div>

      {/* Contenu du rapport */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '20px', border: '1px solid #e5e7eb', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
        <div style={{ fontWeight: 700, fontSize: '15px', color: '#1f2937', marginBottom: '12px' }}>📋 Contenu du rapport PDF</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          {[
            '1. Performance globale (CA, devis, taux conversion)',
            '2. Performance par commerciale (classement)',
            '3. Factures (émises, encaissées, impayées)',
            '4. Commissions (dues, versées, en attente)',
            '5. Installations (en cours, terminées)',
            '6. Alertes (factures impayées > 30 jours)',
          ].map(item => (
            <div key={item} style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#065f46' }}>
              ✅ {item}
            </div>
          ))}
        </div>
      </div>

      {/* Test envoi manuel */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '20px', border: '1px solid #e5e7eb', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
        <div style={{ fontWeight: 700, fontSize: '15px', color: '#1f2937', marginBottom: '8px' }}>🧪 Test d'envoi manuel</div>
        <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>
          Pour tester, connectez-vous au VPS et exécutez :<br/>
          <code style={{ background: '#f1f5f9', padding: '6px 10px', borderRadius: '6px', display: 'block', marginTop: '8px', fontSize: '12px' }}>
            node /var/www/solarquotepro/scripts/rapport_mensuel.js
          </code>
        </div>
        <div style={{ fontSize: '12px', color: '#9ca3af' }}>
          Pour voir les logs du cron :<br/>
          <code style={{ background: '#f1f5f9', padding: '6px 10px', borderRadius: '6px', display: 'block', marginTop: '4px', fontSize: '12px' }}>
            tail -f /var/log/rapport_mensuel.log
          </code>
        </div>
      </div>
    </div>
  );
};

export default RapportMensuelManager;
